import { render, staticRenderFns } from "./MembersForm.vue?vue&type=template&id=2c5b731f"
import script from "./MembersForm.vue?vue&type=script&lang=js"
export * from "./MembersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports